import { useFormikContext } from "formik";
import { Trans } from "react-i18next";
import { CaptchaComponent, useCaptcha } from "./CaptchaComponent";
import ModalComponent, { ModalHeader } from "./Modal";

const InputHiddenCaptchaModal = ({
  modalProp,
  action = "claim_microsite_name",
}) => {
  const captchaProp = useCaptcha();
  const { setFieldValue, submitForm } = useFormikContext();
  return (
    <ModalComponent {...modalProp} disabled>
      <div className="text-center">
        <ModalHeader {...modalProp}>
          <Trans i18nKey="solve_captcha">Solve Captcha</Trans>
        </ModalHeader>
      </div>
      <p className="text-center">
        <Trans i18nKey="complete_captcha">
          Please complete the captcha below
        </Trans>
      </p>
      <div className="flex justify-center my-6">
        <CaptchaComponent
          prop={captchaProp}
          action={action}
          onSuccess={(token) => {
            setFieldValue("captcha", token);
            setTimeout(() => {
              modalProp.close();
              submitForm();
            }, 200);
          }}
        />
      </div>
    </ModalComponent>
  );
};

export default InputHiddenCaptchaModal;
